import styled from "styled-components";
import { Icon, Text } from "../../../../services/visualLibraryService";

export const MainWrapper = styled.div`
  position: relative;
`;
export const InactiveContent = styled.div``;
export const LockMainWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: ${props => `${props.direction === "rtl" ? "35%" : "60%"}`};
  transform: translate(-50%, -50%);
  height: ${props => `${props.isError ? "19.8125rem" : "14.5rem"}`};
  width: 20rem;
  border-radius: 1.5rem;

  z-index: 10000;
`;
export const LockWrapperShade = styled.div`
  background-color: ${props => props.theme.color.greyBlack};
  box-shadow: 0 0.625rem 1.25rem 0 rgba(0, 0, 0, 0.7);
  opacity: 0.8;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -9;
  border-radius: 1.5rem;
`;

export const LockWrapper = styled.div`
  margin: 2.5rem 1.5rem;
  text-align: center;
`;

export const IconStyled = styled(Icon)`
  fill: ${props => props.isError ?  props.theme.color.white : props.theme.color.primary};
  height: 3.75rem;
  width: 3.75rem;
  margin-bottom: 1.575rem;
`;

export const InactiveText = styled(Text)`
  color: ${props => props.theme.color.white};
  font-size: 1.6rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  letter-spacing: 0;
  line-height: 2.125rem;
  text-align: center;
`;

export const ErrorDescription = styled(Text)`
  color: ${props => props.theme.color.white};
  font-size: 1.125rem;
  letter-spacing: 0;
  line-height: 1.25rem;
  text-align: center;
`;
